export const ALL_ARTICLES_ENDPOINT = '/p/v4/kb/articles';
export const ARTICLE_BY_ID_ENDPOINT = '/p/v4/kb/articles/:articleId';
export const ARTICLES_SEARCH_ENDPOINT =
  '/p/v4/kb/articles/search?pageSize=100&page=1&term=:term&lang=:lang&knowledgeBaseId=:knowledgeBaseId';
export const KNOWLEDGE_BASE_ARTICLE_RATING_ENDPOINT =
  '/p/v4/kb/articles/:articleId/feedback?lang=:lang';
export const KNOWLEDGE_BASE_ARTICLE_FEEDBACK_ENDPOINT =
  '/p/v4/kb/articles/:articleId/feedback/:id';

export const FEATURED_KNOWLEDGE_BASE_ARTICLES =
  '/p/v4/kb/featured-articles?knowledgeBaseId=:knowledgeBaseId&lang=:lang';
